<div class="input-group">
  <input
    type="text"
    style="padding: 22px 35px 22px 22px; border-radius: 25px"
    class="form-control"
    placeholder="Search"
    class="form-control"
    [(ngModel)]="searchField"
    [typeahead]="dataSource"
    (typeaheadOnSelect)="openInNewWindow($event)"
    [typeaheadAsync]="true"
    [typeaheadMinLength]="0"
    [optionsListTemplate]="searchTemplate"
    typeaheadOptionField="policyNumber" />
  <div
    class="input-group-append"
    style="cursor: pointer; position: absolute; right: 15px; top: 10px; z-index: 9"
    *ngIf="searchField"
    (click)="searchField = ''">
    <span style="color: #aaa; font-size: 1.2em"><i class="fa fa-close"></i></span>
  </div>
  <div class="input-group-append" style="position: absolute; right: 15px; top: 10px; z-index: 9" *ngIf="!searchField">
    <span style="color: #2763cd; font-size: 1.2em"><i class="fa fa-search"></i></span>
  </div>

  <ng-template #searchTemplate let-matches="matches" let-query="query" let-typeaheadTemplateMethods>
    <table class="search-results" style="width: 500px">
      <tr
        class="custom-list-group-item"
        *ngFor="let match of matches"
        style="display: table-row; min-height: 20px"
        [class.active]="typeaheadTemplateMethods.isActive(match)"
        (click)="openInNewWindow(match)"
        (mouseenter)="typeaheadTemplateMethods.selectActive(match)">
        <td>
          <div>
            <span [innerHTML]="match.item.policyNumber | highlightSearch: searchField"></span> |
            <span [innerHTML]="match.item.customerName | highlightSearch: searchField"></span>
          </div>
          <div *ngIf="match.item?.matches?.vendor">
            Vendor: <span [innerHTML]="match.item.vendor.name | highlightSearch: searchField"></span>
          </div>
          <div *ngIf="match.item?.matches?.inspector">
            Inspector: <span [innerHTML]="match.item.inspector.name | highlightSearch: searchField"></span>
          </div>
          <div *ngIf="match.item?.matches?.location">
            Location:
            <span [innerHTML]="match.item.address | highlightSearch: searchField"></span>,
            <span [innerHTML]="match.item.city | highlightSearch: searchField"></span>,
            <span [innerHTML]="match.item.state | highlightSearch: searchField"></span>
          </div>
        </td>
        <td
          [ngStyle]="{ color: statusColor(match.item.status) }"
          style="
            vertical-align: top;
            text-align: left;
            display: list-item;
            list-style-type: disc;
            list-style-position: inside;
            white-space: nowrap;
          ">
          {{ getStatusAsText(match.item) }}
        </td>
      </tr>
    </table>
  </ng-template>
</div>
